export const formatDate = (
  dateString: string,
  locale: string = 'en',
  t?: (key: string) => string
): string => {
  // Handle UTC date conversion more directly
  let date: Date;

  if (dateString.endsWith('Z') || dateString.includes('T')) {
    // It's a UTC date, convert to local time
    const utcDate = new Date(dateString);
    // Create a new date object in local timezone
    date = new Date(utcDate.getTime());
  } else {
    // It's already a local date string
    date = new Date(dateString);
  }

  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  // Reset time part for date comparison (all in local timezone)
  const dateToCheck = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
  const todayToCheck = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const yesterdayToCheck = new Date(
    yesterday.getFullYear(),
    yesterday.getMonth(),
    yesterday.getDate()
  );

  if (dateToCheck.getTime() === todayToCheck.getTime()) {
    return t ? t('today') : locale === 'ar' ? 'اليوم' : 'Today';
  } else if (dateToCheck.getTime() === yesterdayToCheck.getTime()) {
    return t ? t('yesterday') : locale === 'ar' ? 'أمس' : 'Yesterday';
  }

  // Use translation system for month names
  if (t) {
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const monthName = monthNames[date.getMonth()];
    const translatedMonth = t(monthName);

    return `${date.getDate()} ${translatedMonth} ${date.getFullYear()}`;
  }

  //? if these is no t argument, use the locale to determine month names
  // Fallback: Use Gregorian months even for Arabic locale
  // Arabic month names in Gregorian calendar
  const arabicMonthNames = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر',
  ];

  const englishMonthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const monthName =
    locale === 'ar'
      ? arabicMonthNames[date.getMonth()]
      : englishMonthNames[date.getMonth()];

  return `${date.getDate()} ${monthName} ${date.getFullYear()}`;
};
